import http from 'Demora/http';

const rs = window.reduxStore;

export default function f() {
	if (!areFeelsLoaded()) {
		http
			.get('/data/feels')
			.then((data) => {
				if (!data.rufP) {
					return;
				}

				rs.dispatch({
					type: 'STORE_FEELS',
					data: data,
				});
			})
			.catch((e) => {
				throw e;
			});
	}
}

export function areFeelsLoaded() {
	return Object.keys(rs.getState().feels).length > 0;
}
